export default function () {
  return {
    page: 1,
    totalPages: 0,
    perPage: 20,
    searchParams: {},
    boardingPlaces: [],
    showDeleteConfirmation: false,
    deletingId: null,
    deletingObj: null,
    apiUrl: process.env.VUE_APP_API_URL,
    replacementPlace: null,
    fields: [
      {
        key: 'title',
        label: 'Local'
      },
      {
        key: 'city',
        label: 'Cidade',
      },
      {
        key: 'state',
        label: 'Estado'
      },
      {
        key: 'actions',
        label: ''
      }
    ]
  }
}
